import { IonContent, IonInput, IonPage, IonText } from "@ionic/react"
import { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router";
import { useParams } from "react-router-dom";
import DataTable from "react-data-table-component";
import Head from "../../Header";
import Sidebar from "../../Sidebar";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { Modal } from "react-bootstrap";
import service from "../../../Service/service";
import swal from 'sweetalert';

const GendralActivityAssign: React.FC = () => {

    const history = useHistory();
    {/* ------------------------Project Id From Hr Project  ------------------------------*/ }
    const location: any = useLocation();
    const projectId = location.state.proId;

    const [createdBy] = useState(localStorage.getItem("SignupEmpId"));
    const [token] = useState(localStorage.getItem("SignupEmpId"));

    const [data, setData] = useState([]);
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    {/* ------------------------Checkbox------------------------------*/ }
    const [isCheckboxSelected, setIsCheckboxSelected] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);

    useEffect(() => {
        if (token === null) {
            history.push("/login");
        } else {
            console.log(location.state)
        }
    }, [token, history]);

    data.forEach((item: any, index: any) => { item.serial = index + 1; });

    {/* ------------------------Load General Activity ------------------------------*/ }

    const LoadGeneralActivity = () => {
        service.GetGeneralActivity()
            .then((response) => {
                console.log(response, "data")
                if (response.data.Status === 200) {
                    setData(response.data.Data);
                }
                else {
                    setData([]);
                }
            })
            .catch((error) => {
                console.log(error)
            })
    }

    useEffect(() => {
        LoadGeneralActivity()
        console.log("General employee")
        console.log(projectId, "kkkkkkkk")
    }, []);
    {/* ------------------------Check Box------------------------------*/ }

    const GeneralId = (e: any) => {
        const selectedRowIds = e.selectedRows.map((row: any) => row.id);
        setSelectedRows(selectedRowIds);
        console.log("Selected Gendral IDs:", selectedRowIds);
    };

    {/* --------------------Save general Activity-------------------- */ }

    const AssignGeneralActivity = () => {
        console.log("Selected Row IDs:", selectedRows);
        if (selectedRows.length === 0) {
            swal("", "Select Actitivy's to assign", "info");
        } else {
            service
                .GeneralActivity(projectId, selectedRows, createdBy)
                .then((response) => {
                    console.log("AssignGeneralActivity");
                    console.log(response);
                    if (response.data.status === "200") {
                        swal("", response.data.message, "success")
                            .then(() => {
                                setTimeout(() => {
                                    history.push("/HRProject");
                                }, 0);
                            });

                    }
                })
                .catch((error) => {
                    console.error(error);
                    swal("", "An error occurred during the transfer.", "error");
                });
        }

    };

    {/* ----------------------- Datatable for general activtiy  ------------------------------*/ }
    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: false,
            width: "250px"
        },
        {
            name: "Parent Activity",
            selector: (itm: any) => itm.parentActivityId,
            sortable: true,
            width: "250px"
        },
        {
            name: "Activity Meta",
            selector: (itm: any) => itm.activityMeta,
            sortable: true,
        },
        {
            name: "Activity Meta Description",
            selector: (itm: any) => itm.activityMetaDescription,
            sortable: true,
        },
    ]

    const datatable = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px"
            },
        },
        cells: {
            style: {
                fontSize: "16px"
            }
        }
    };

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }

        };

        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )

    }, [filterText, resetPaginationToggle]);
    {/* --------------------------------------------General Activity---------------------------------------------- */ }
    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>General Activity</h3>
                                </div>
                            </div>
                            <div className="table-responsive" style={{ marginTop: "1%" }}>
                                <DataTable
                                    columns={columns}
                                    data={datatable}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    subHeader
                                    selectableRows
                                    onSelectedRowsChange={GeneralId}
                                    subHeaderComponent={subHeaderComponent}
                                    customStyles={customStyles}
                                />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                <div className="col-md-4" style={{ paddingTop: '10px' }}>
                                    <button onClick={AssignGeneralActivity} className="btn btn-orange btn-block w-100">
                                        Assign General Activity
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </IonContent>
        </IonPage>
    )
}
export default GendralActivityAssign;